export default {
      id: "map-usage",
      viewBox: "0 0 16.09 21.834",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#map",
      toString: function () {
        return this.url;
      }
    }